import { render } from "./Postfooter.vue?vue&type=template&id=de6e2c12&scoped=true"
import script from "./Postfooter.vue?vue&type=script&lang=js"
export * from "./Postfooter.vue?vue&type=script&lang=js"

import "./Postfooter.vue?vue&type=style&index=0&id=de6e2c12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de6e2c12"]])

export default __exports__